import { useState } from "react";
import { Award } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { HonorAdminCard } from "@/components/admin/HonorAdminCard";

export const HonorPromote = ({ p, onDone }) => {
  const [open, setOpen] = useState(false);
  const change = (v) => { setOpen(v); if (!v) onDone?.(); };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="profile-honor-promote"
        className="tier-gold honor-chip w-full sm:w-auto h-11 px-5 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold active:scale-95 transition-transform">
        <Award className="w-4 h-4" /> {p.is_honor ? "Ehrenstatus verwalten" : "Zum Ehrenmitglied befördern"} <span className="text-[10px] font-bold opacity-70">(Admin)</span>
      </button>
      <Dialog open={open} onOpenChange={change}>
        <DialogContent className="rounded-3xl max-w-md" data-testid="profile-honor-dialog">
          <DialogHeader>
            <DialogTitle>{p.name} als Ehrenmitglied</DialogTitle>
            <DialogDescription>Schalter an, Stufe und optional einen Ehrentitel wählen – fertig.</DialogDescription>
          </DialogHeader>
          <HonorAdminCard userId={p.user_id} name={p.name} />
        </DialogContent>
      </Dialog>
    </>
  );
};
